import React, { useEffect, useState } from "react";
import { ChevronDown, User, Users }   from "react-feather";
import { Tag }                        from "@/Components/Tag";
import { usePage }                    from "@inertiajs/inertia-react";
import { ROLE_ID }                    from "@/Enums/roles";
import { EditQuestion }               from "@/Components/Questions/EditQuestion";
import { useAtom }                    from "jotai";
import { editQuestionAtom }           from "@/Stores";
import { ReportQuestion }             from "@/Components/Questions/ReportQuestion";
import { QUESTION_TYPES }             from "@/Enums/question_types";

export function ExpandableBlockQuestion({
  question,
  derivedTeam = null,
  showTeam = false,
  isNew = false
}) {
  const user    = usePage().props?.auth?.user?.data || {}
  const isOwner = user.organization_role_id === ROLE_ID.OWNER;
  const isTypeHistorical = question?.type?.enum === QUESTION_TYPES.Historical
  const hasPermissionToEdit = isOwner && ! isTypeHistorical;

  const [showEdit, setShowEdit]     = useState(false);
  const [showReport, setShowReport] = useState(false);

  const [store] = useAtom(editQuestionAtom);

  useEffect(() => {
    if (showEdit && store.id !== question.id) {
      setShowEdit(false);
    }
  }, [store])

  const getOpenState = () => {
    return showEdit || showReport;
  }

  const toggleOpen = (type, forced = null) => {
    if (type === 'edit') {
      if (!showEdit) {
        setShowReport(false);
      }
      setShowEdit(forced === null ? !showEdit : forced);
    } else if (type === 'report') {
      if (!showReport) {
        setShowEdit(false);
      }
      setShowReport(forced === null ? !showReport : forced);
    } else {
      setShowReport(false);
      setShowEdit(false);
    }
  }

  return (
    <div className={`p-4 my-2 bg-white ${isNew ? 'slide-in-top-fade-bg-green' : ''}`}>
      <div className={`${getOpenState() ? 'bg-gray-lighter p-2' : ''} flex flex-col sm:flex-row sm:justify-between sm:items-center sm:px-4 sm:h-16`}>
        <div>
          <div className="flex flex-row items-center">
            <h4 title={question.title} className="mr-2 font-bold text-md md:text-lg sm:truncate sm:max-w-[250px] md:max-w-[350px] lg:max-w-[400px]">{question.title}</h4>
          </div>
          {!getOpenState() &&
            question.tags && question.tags.map((tag, i) => <Tag
              key={`question_${question.id}_tag_${i}`}
              className="mr-1"
            >{tag.name}</Tag>)
          }
        </div>
        <div className="flex flex-wrap justify-between gap-2 sm:justify-end sm:flex-nowrap">

          {!getOpenState() && <>
            <div className="flex flex-wrap w-full gap-4 my-4 sm:w-auto sm:my-0 sm:flex-nowrap">
              {showTeam && derivedTeam &&
              <div className="flex flex-row items-center mr-2">
                <Users className="mr-2"/>
                {derivedTeam.name}
              </div>
              }
              {!showTeam && ! isTypeHistorical &&
              <div className="flex flex-row items-center mr-2">
                <User className="mr-2"/>
                {question?.pivot?.user ? `${question.pivot.user.firstname} ${question.pivot.user.surname.charAt(0)}` : 'No reporter'}
              </div>
              }
            </div>
            {hasPermissionToEdit && <button className="btn-blue-outline grow-0 h-14" onClick={() => toggleOpen('edit')}>Edit</button>}
            <button className="btn-blue grow-0 h-14" onClick={() => toggleOpen('report')}>Report</button>
          </>}

          {getOpenState() && <>
            {hasPermissionToEdit && <button className="underline hover:no-underline text-blue" onClick={() => toggleOpen(showReport ? 'edit' : 'report', true)}>
              {showReport ? 'Edit Activity' : 'Report'}
            </button>}
            <button className="flex items-center justify-end w-10 h-10" onClick={() => toggleOpen(null)}>
              <ChevronDown className="rotate-180"/>
            </button>
          </>}
        </div>
      </div>

      {showEdit && <EditQuestion question={question} toggleOpen={toggleOpen}/>}
      {showReport && <ReportQuestion question={question} derivedTeam={derivedTeam} toggleOpen={toggleOpen}/>}
    </div>
  )
}
